import { Box } from "@mui/material"

const validateData = (data) => {

    const response = []

    if (!data?.nome?.length > 0)
        response.push(<Box>Digite o nome do credenciado.</Box>)

    if (!data?.validadeinicial)
        response.push(<Box>Digite a validade inicial.</Box>)

    if (!data?.validadefinal)
        response.push(<Box>Digite a validade final.</Box>)

    if (!data?.acesso)
        response.push(<Box>Selecione um acesso.</Box>)

    if (response.length === 0)
        return ''

    return (response)
}

export default validateData